"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import ProductCard from "@/themes/default/elements/Product/ProductCard";
import { MainShopProduct } from "@/core/models/shop-product-model";
import { Heading } from "@/components/ui/Heading";
import { ArrowLeftIcon } from "lucide-react";
import Link from "next/link";
import { useDictionary } from "@/core/hooks/use-dictionary";

export default function ProductBar({ data }: { data: MainShopProduct }) {
  const { dictionary } = useDictionary();

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-center mb-2 max-md:flex-col max-md:items-start">
        <div>
          <Heading level={3}>{data.title}</Heading>
          <p className="text-primary-600">{data.description}</p>
        </div>
        {data.link && (
          <Link className="text-primary-600 flex items-center gap-1" href={data.link}>
            {dictionary.ui?.pages.seeAll}
            <ArrowLeftIcon className="stroke-1 size-4 ltr:rotate-180" />
          </Link>
        )}
      </div>
      <Swiper
        modules={[Scrollbar]}
        spaceBetween={16}
        slidesPerView="auto"
        scrollbar={{ draggable: true, dragSize: 100 }}
        className="w-full"
        style={{ paddingBottom: "40px" }}
      >
        {data.items.map((item) => (
          <SwiperSlide key={item.id} style={{ width: "300px" }}>
            <ProductCard product={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
